import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CloseIconStyled } from '../../../theme/style';
import DeleteContentModal from '../../Modals/DeleteModal/deleteModal';

interface DeleteTenantCellInterface {
    tenantId: number;
    tenantName: string;
    handleDeleteTenant: (tenantId: number, tenantName: string) => void
}

const DeleteTenantCell: FC<DeleteTenantCellInterface> = ({ tenantId, tenantName, handleDeleteTenant }) => {
    const { t } = useTranslation('settings');
    const [openDeleteModal, setOpenDeleteModal] = useState<boolean>(false);
    const handleDeleteTenantTest = () => {
        handleDeleteTenant(tenantId, tenantName);
        setOpenDeleteModal(false);
    };
    const modalTitle = t('tenants.deleteTenantModal', { tenantName });

    return (
        <>
            <CloseIconStyled onClick={() => setOpenDeleteModal(true)} />
            {openDeleteModal && (
                <DeleteContentModal
                    handleClickConfirm={handleDeleteTenantTest}
                    handleClose={() => setOpenDeleteModal(false)}
                    openModal={openDeleteModal}
                    title={modalTitle}
                />
            )}
        </>
    );
};

export default DeleteTenantCell;
